/*
 * bor-cro-fixes.js
 * Correcciones CRO para Bor Boutique — agosto 2026
 *
 * FIX 1 — Monto de "te faltan X para envío gratis" en pesos chilenos.
 * FIX 2 — Línea de cuotas bajo el precio en la ficha de producto.
 * FIX 3 — Barra fija de compra en móvil: precio y talla seleccionada.
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
   * Utilidades de moneda (CLP: sin decimales, punto como miles)
   * --------------------------------------------------------------- */

  // 6000000 (centavos Shopify) -> "$60.000"
  function formatearCLP(centavos) {
    return '$' + separarMiles(Math.round(centavos / 100));
  }

  function separarMiles(entero) {
    return String(entero).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // "$349.990" -> 349990 ; "349.990 CLP" -> 349990
  function pesosDesdeTexto(texto) {
    if (!texto) return 0;
    var soloDigitos = texto.replace(/[^\d]/g, '');
    return soloDigitos ? parseInt(soloDigitos, 10) : 0;
  }

  /* ---------------------------------------------------------------
   * FIX 1 — Barra de envío gratis
   *
   * theme.js (clase CartShippingMessage, línea 9667) hace:
   *     element.innerHTML = leftToSpend.replace('.00', '');
   * Ese reemplazo asume una moneda con dos decimales. En CLP el punto
   * es separador de miles, así que "$60.000" queda en "$600": se come
   * dígitos reales. Rompe todo monto múltiplo redondo de mil.
   *
   * En vez de intentar deshacer el string corrupto (imposible: "$600"
   * es ambiguo), recalculamos el monto desde el carrito real.
   * --------------------------------------------------------------- */

  var SELECTOR_MENSAJE = '[data-cart-message]';
  var SELECTOR_MONTO = '[data-left-to-spend]';

  function corregirMontosEnvio(totalCarrito) {
    var mensajes = document.querySelectorAll(SELECTOR_MENSAJE);
    if (!mensajes.length) return;

    Array.prototype.forEach.call(mensajes, function (mensaje) {
      var limite = parseInt(mensaje.getAttribute('data-limit'), 10);
      if (!limite || isNaN(limite)) return;

      var falta = limite * 100 - totalCarrito;
      if (falta < 0) falta = 0;

      Array.prototype.forEach.call(mensaje.querySelectorAll(SELECTOR_MONTO), function (span) {
        var correcto = formatearCLP(falta);
        if (span.textContent.trim() !== correcto) span.textContent = correcto;
      });
    });
  }

  function sincronizarEnvio(totalConocido) {
    if (typeof totalConocido === 'number') {
      corregirMontosEnvio(totalConocido);
      return;
    }
    if (!document.querySelector(SELECTOR_MENSAJE)) return;
    var ruta = (window.theme && theme.routes && theme.routes.cart) || '/cart';
    window
      .fetch(ruta + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (carrito) {
        if (carrito && typeof carrito.total_price === 'number') corregirMontosEnvio(carrito.total_price);
      })
      .catch(function () { /* silencioso */ });
  }

  /* ---------------------------------------------------------------
   * FIX 2 — Cuotas bajo el precio
   *
   * La barra de anuncios promete "3 y 6 cuotas sin interés" pero eso
   * no se repite en el punto de decisión. A un ticket de $350.000 —
   * unas 20 veces el ticket promedio de vestuario en Chile — el freno
   * no es la motivación, es la capacidad percibida de pago.
   * --------------------------------------------------------------- */

  var CUOTAS = 6;
  var MINIMO_PARA_MOSTRAR = 50000; // bajo esto la cuota no aporta nada

  function elementoPrecio() {
    var candidatos = [
      '.product__price [data-price]',
      '.product__price .price',
      '[data-product-price]',
      '.product__price'
    ];
    for (var i = 0; i < candidatos.length; i++) {
      var el = document.querySelector(candidatos[i]);
      if (el && pesosDesdeTexto(el.textContent) > 0) return el;
    }
    return null;
  }

  function precioActual() {
    var el = elementoPrecio();
    return el ? pesosDesdeTexto(el.textContent) : 0;
  }

  function pintarCuotas() {
    if (!/\/products\//.test(location.pathname)) return;

    var precio = precioActual();
    var contenedor = elementoPrecio();
    if (!contenedor) return;

    var existente = document.querySelector('.bor-cuotas');

    if (!precio || precio < MINIMO_PARA_MOSTRAR) {
      if (existente) existente.remove();
      return;
    }

    var porCuota = Math.ceil(precio / CUOTAS);
    var texto =
      'o <strong>' + CUOTAS + ' cuotas de $' + separarMiles(porCuota) + '</strong> sin interés';

    if (existente) {
      if (existente.innerHTML !== texto) existente.innerHTML = texto;
      return;
    }

    var p = document.createElement('p');
    p.className = 'bor-cuotas';
    p.innerHTML = texto;

    var bloquePrecio = contenedor.closest('[class*="product__block"]') || contenedor;
    bloquePrecio.parentNode.insertBefore(p, bloquePrecio.nextSibling);
  }

  /* ---------------------------------------------------------------
   * FIX 3 — Barra fija de compra en móvil
   *
   * El tema trae una barra fija (#sticky-atc-bar) que solo contiene el
   * texto "Agregar al carrito": sin precio, sin talla, sin producto.
   * Obliga a volver a subir para saber qué se está comprando.
   * --------------------------------------------------------------- */

  function tallaSeleccionada() {
    var marcado = document.querySelector(
      '.product-form input[type="radio"]:checked, [data-variant-input]:checked, fieldset input[type="radio"]:checked'
    );
    if (marcado) {
      var etiqueta =
        document.querySelector('label[for="' + marcado.id + '"]') ||
        marcado.closest('label');
      var txt = (etiqueta ? etiqueta.textContent : marcado.value) || '';
      txt = txt.trim();
      if (txt && txt.length <= 6) return txt;
    }
    return '';
  }

  function pintarBarraFija() {
    var barra = document.getElementById('sticky-atc-bar');
    if (!barra) return;

    var precio = precioActual();
    if (!precio) return;

    var info = barra.querySelector('.bor-sticky-info');
    if (!info) {
      info = document.createElement('div');
      info.className = 'bor-sticky-info';
      info.style.cssText =
        'display:flex;justify-content:space-between;align-items:baseline;' +
        'gap:12px;margin-bottom:8px;font-size:13px;color:#1d1d1b;';
      barra.insertBefore(info, barra.firstChild);
    }

    var talla = tallaSeleccionada();
    var porCuota = Math.ceil(precio / CUOTAS);

    info.innerHTML =
      '<span style="font-weight:600">$' + separarMiles(precio) +
      (talla ? ' <span style="font-weight:400;color:#6b6b6b">· Talla ' + talla + '</span>' : '') +
      '</span>' +
      '<span style="color:#6b6b6b;font-size:12px">' + CUOTAS + ' x $' + separarMiles(porCuota) + '</span>';
  }

  /* ---------------------------------------------------------------
   * Orquestación
   * --------------------------------------------------------------- */

  function sincronizarTodo(totalCarrito) {
    try { sincronizarEnvio(totalCarrito); } catch (e) {}
    try { pintarCuotas(); } catch (e) {}
    try { pintarBarraFija(); } catch (e) {}
  }

  function sincronizarDiferido(total) {
    setTimeout(function () { sincronizarTodo(total); }, 60);
    setTimeout(function () { sincronizarTodo(total); }, 400);
    setTimeout(function () { sincronizarTodo(total); }, 1200);
  }

  document.addEventListener('theme:cart:change', function (e) {
    var total = e && e.detail && e.detail.cart ? e.detail.cart.total_price : undefined;
    sincronizarDiferido(total);
  });
  document.addEventListener('theme:cart:reload', function () { sincronizarDiferido(); });
  document.addEventListener('theme:variant:change', function () { sincronizarDiferido(); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"], select')) {
      sincronizarDiferido();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sincronizarDiferido(); });
  } else {
    sincronizarDiferido();
  }
  window.addEventListener('load', function () { sincronizarDiferido(); });
})();
